import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';

export const catalogReactFr = createTranslationMessages({
  ref: catalogReactTranslationRef,
  full: true,
  messages: {
    'catalogFilter.title': 'Filtres',
    'catalogFilter.buttonTitle': 'Filtres',
    'entityKindPicker.title': 'Type',
    'entityKindPicker.errorMessage':
      "Échec du chargement des types d'entités",
    'entityLifecyclePicker.title': 'Cycle de vie',
    'entityNamespacePicker.title': 'Espace de noms',
    'entityOwnerPicker.title': 'Propriétaire',
    'entityProcessingStatusPicker.title': 'Statut de traitement',
    'entityTagPicker.title': 'Tags',
    'entityPeekAheadPopover.title':
      "Explorez l'entité pour voir tous les tags.",
    'entityPeekAheadPopover.entityCardActionsAriaLabel': 'Afficher',
    'entityPeekAheadPopover.entityCardActionsTitle': 'Afficher les détails',
    'entityPeekAheadPopover.emailCardAction.title':
      'Envoyer un e-mail à {{email}}',
    'entityPeekAheadPopover.emailCardAction.ariaLabel': 'E-mail',
    'entityPeekAheadPopover.emailCardAction.subTitle': 'mailto {{email}}',
    'entitySearchBar.placeholder': 'Rechercher',
    'entityTypePicker.title': 'Type',
    'entityTypePicker.errorMessage':
      "Échec du chargement des types d'entités",
    'entityTypePicker.optionAllTitle': 'tous',
    'favoriteEntity.addToFavorites': 'Ajouter aux favoris',
    'favoriteEntity.removeFromFavorites': 'Retirer des favoris',
    'inspectEntityDialog.title': "Inspecteur d'entité",
    'inspectEntityDialog.closeButtonTitle': 'Fermer',
    'inspectEntityDialog.tabsAriaLabel': "Options de l'inspecteur",
    'inspectEntityDialog.ancestryPage.title': 'Ascendance',
    'inspectEntityDialog.ancestryPage.description':
      "Voici l'ascendance des entités au-dessus de l'entité courante — c'est-à-dire la ou les chaînes d'entités menant à l'entité courante, où {{processorsLink}} des entités enfants qui ont finalement conduit à l'existence de l'entité courante. Notez qu'il s'agit d'un mécanisme complètement différent des relations.",
    'inspectEntityDialog.ancestryPage.processorsLink':
      'des processeurs ont émis',
    'inspectEntityDialog.colocatedPage.title': 'Colocalisées',
    'inspectEntityDialog.colocatedPage.description':
      "Voici les entités colocalisées avec cette entité — c'est-à-dire qu'elles proviennent de la même source de données (par ex. du même fichier YAML) ou de la même origine (par ex. l'URL enregistrée à l'origine).",
    'inspectEntityDialog.colocatedPage.alertNoLocation':
      "L'entité ne comportait aucune information d'emplacement.",
    'inspectEntityDialog.colocatedPage.alertNoEntity':
      "Il n'y avait aucune autre entité à cet emplacement.",
    'inspectEntityDialog.colocatedPage.locationHeader': 'Au même emplacement',
    'inspectEntityDialog.colocatedPage.originHeader': 'À la même origine',
    'inspectEntityDialog.colocatedPage.entityListAriaLabel':
      'Entités colocalisées',
    'inspectEntityDialog.jsonPage.title': 'Entité au format JSON',
    'inspectEntityDialog.jsonPage.description':
      "Voici les données brutes de l'entité telles que reçues du catalogue, au format JSON.",
    'inspectEntityDialog.overviewPage.title': "Vue d'ensemble",
    'inspectEntityDialog.overviewPage.metadata.title': 'Métadonnées',
    'inspectEntityDialog.overviewPage.labels': 'Labels',
    'inspectEntityDialog.overviewPage.status.title': 'Statut',
    'inspectEntityDialog.overviewPage.identity.title': 'Identité',
    'inspectEntityDialog.overviewPage.annotations': 'Annotations',
    'inspectEntityDialog.overviewPage.tags': 'Tags',
    'inspectEntityDialog.overviewPage.relation.title': 'Relations',
    'inspectEntityDialog.overviewPage.copyAriaLabel': 'Copier {{label}}',
    'inspectEntityDialog.overviewPage.copiedStatus': 'Copié',
    'inspectEntityDialog.overviewPage.helpLinkAriaLabel': 'En savoir plus',
    'inspectEntityDialog.yamlPage.title': 'Entité au format YAML',
    'inspectEntityDialog.yamlPage.description':
      "Voici les données brutes de l'entité telles que reçues du catalogue, au format YAML.",
    'inspectEntityDialog.tabNames.json': 'JSON brut',
    'inspectEntityDialog.tabNames.yaml': 'YAML brut',
    'inspectEntityDialog.tabNames.overview': "Vue d'ensemble",
    'inspectEntityDialog.tabNames.ancestry': 'Ascendance',
    'inspectEntityDialog.tabNames.colocated': 'Colocalisées',
    'unregisterEntityDialog.title':
      'Voulez-vous vraiment désinscrire cette entité ?',
    'unregisterEntityDialog.cancelButtonTitle': 'Annuler',
    'unregisterEntityDialog.deleteButtonTitle': "Supprimer l'entité",
    'unregisterEntityDialog.deleteEntitySuccessMessage':
      'Entité {{entityName}} supprimée',
    'unregisterEntityDialog.onlyDeleteStateTitle':
      "Cette entité ne semble pas provenir d'un emplacement enregistré. Vous avez donc uniquement la possibilité de la supprimer définitivement du catalogue.",
    'unregisterEntityDialog.errorStateTitle': 'Erreur interne : état inconnu',
    'unregisterEntityDialog.bootstrapState.title':
      'Vous ne pouvez pas désinscrire cette entité, car elle provient d\'une configuration Backstage protégée (emplacement "{{location}}"). Si vous pensez qu\'il s\'agit d\'une erreur, veuillez contacter l\'intégrateur {{appTitle}}.',
    'unregisterEntityDialog.bootstrapState.advancedDescription':
      "Vous avez la possibilité de supprimer l'entité elle-même du catalogue. Notez que cela ne doit être fait que si vous savez que le fichier de catalogue a été supprimé de son emplacement d'origine, ou déplacé. Si ce n'est pas le cas, l'entité réapparaîtra rapidement lors du prochain cycle d'actualisation effectué par le catalogue.",
    'unregisterEntityDialog.bootstrapState.advancedOptions':
      'Options avancées',
    'unregisterEntityDialog.unregisterState.title':
      'Cette action désinscrira les entités suivantes :',
    'unregisterEntityDialog.unregisterState.description':
      "Pour annuler, il suffit de réinscrire l'entité dans {{appTitle}}.",
    'unregisterEntityDialog.unregisterState.subTitle':
      "Situées à l'emplacement suivant :",
    'unregisterEntityDialog.unregisterState.advancedDescription':
      "Vous avez également la possibilité de supprimer l'entité elle-même du catalogue. Notez que cela ne doit être fait que si vous savez que le fichier de catalogue a été supprimé de son emplacement d'origine, ou déplacé. Si ce n'est pas le cas, l'entité réapparaîtra rapidement lors du prochain cycle d'actualisation effectué par le catalogue.",
    'unregisterEntityDialog.unregisterState.advancedOptions':
      'Options avancées',
    'unregisterEntityDialog.unregisterState.unregisterButtonTitle':
      "Désinscrire l'emplacement",
    'userListPicker.defaultOrgName': 'Entreprise',
    'userListPicker.orgFilterAllLabel': 'Tous',
    'userListPicker.personalFilter.title': 'Personnel',
    'userListPicker.personalFilter.ownedLabel': 'Possédées',
    'userListPicker.personalFilter.starredLabel': 'Favoris',
    'entityTableColumnTitle.name': 'Nom',
    'entityTableColumnTitle.type': 'Type',
    'entityTableColumnTitle.label': 'Label',
    'entityTableColumnTitle.title': 'Titre',
    'entityTableColumnTitle.description': 'Description',
    'entityTableColumnTitle.domain': 'Domaine',
    'entityTableColumnTitle.system': 'Système',
    'entityTableColumnTitle.namespace': 'Espace de noms',
    'entityTableColumnTitle.tags': 'Tags',
    'entityTableColumnTitle.lifecycle': 'Cycle de vie',
    'entityTableColumnTitle.owner': 'Propriétaire',
    'entityTableColumnTitle.targets': 'Cibles',
    'missingAnnotationEmptyState.title': 'Annotation manquante',
    'missingAnnotationEmptyState.readMore': 'En savoir plus',
    'missingAnnotationEmptyState.annotationYaml':
      "Ajoutez l'annotation au YAML de votre {{entityKind}} comme dans l'exemple mis en évidence ci-dessous :",
    'missingAnnotationEmptyState.generateDescription_one':
      "L'annotation {{annotations}} est manquante. Vous devez ajouter l'annotation à votre {{entityKind}} si vous souhaitez activer cet outil.",
    'missingAnnotationEmptyState.generateDescription_other':
      'Les annotations {{annotations}} sont manquantes. Vous devez ajouter les annotations à votre {{entityKind}} si vous souhaitez activer cet outil.',
    'entityRelationCard.emptyHelpLinkTitle': 'Apprendre comment changer cela',
  },
});
